<template>
	<div class="wrapper">
		<div v-bind:class="!isResult ? 'inner' : 'inner is-result'">
			<section v-bind:class="!isResult ? 'contents' : 'contents is-result'">
				<div class="titleBox">
					<h1 class="titleImg">
						<picture>
							<source
								srcset="../assets/img/kurehaTest/title_main_pc.svg"
								media="(min-width: 901px)"
								width="584"
								height="224"
							/>
							<img
								src="../assets/img/kurehaTest/title_main_sp.svg"
								alt="クレハ検定 環境と社会への取り組み編"
								width="348"
								height="139"
							/>
						</picture>
					</h1>
				</div>
				<!-- クイズ部分 -->
				<div class="quiz_container" v-if="!isResult">
					<div class="quiz_stars" v-if="isAnswer">
						<div class="quiz_star" v-for="(question, index) in this.questions" :key="index">
							<Star :color="starColors[index]" />
						</div>
					</div>
					<!-- 問題番号 -->
					<div class="quiz_num">
						<img
							:class="`is-${questionIndex + 1}`"
							:src="require(`../assets/img/kurehaTest/num0${questionIndex + 1}.png`)"
							:alt="`Q${questionIndex + 1}`"
							width="74"
							height="47.5"
						/>
					</div>
					<!-- 解答 -->
					<div class="answer_lead" v-if="isAnswer">
						<p class="answer_leadTitle">正解は…</p>
						<div class="answer_leadImg">
							<img
								:src="require(`../assets/img/kurehaTest/alp0${currentQuestion.correctNum + 1}.png`)"
								alt=""
								width="330"
								height="477"
							/>
						</div>
						<p class="answer_comment u-rock u-justify">
							{{ currentQuestion.answerComment }}
						</p>
					</div>
					<!-- 問題文 -->
					<p class="quiz_desc" v-if="!isAnswer">
						<span class="u-ds-sp">
							{{ currentQuestion.question[0] }}
						</span>
						<span class="u-ds-pc">
							{{ currentQuestion.question[1] }}
						</span>
					</p>
					<!-- 写真 -->
					<div :class="`quiz_img is-${pageIndex}`">
						<img :src="require(`../assets/img/kurehaTest/q_img0${pageIndex + 1}.jpg`)" alt="" width="800" height="450" />
					</div>
					<!-- 解答ページ下部 -->
					<div v-if="isAnswer">
						<p class="answer_desc u-justify">
							{{ currentQuestion.answerDesc }}
						</p>
						<div class="answer_link">
							<a :href="currentQuestion.answerLink[1]" target="_blank"
								>{{ currentQuestion.answerLink[0] }}<IconBase class="icon_base" iconColor="#00797F"><Blank /></IconBase
							></a>
							<KurehaArrow class="kureha_arrow" :width="1000" />
						</div>
						<div class="answer_btnNext" v-if="!completed">
							<button type="button" class="u-rock" @click="nextQuestion()">
								次の問題へ
								<img src="../assets/img/kurehaTest/arrow.svg" alt="" width="50" height="17.5" />
							</button>
						</div>
					</div>
					<!-- 選択肢 -->
					<ul class="quiz_btnItems" v-if="!isAnswer">
						<li class="quiz_btnItem" v-for="(answer, index) in currentQuestion.answers" :key="index">
							<img
								:src="require(`../assets/img/kurehaTest/alp0${index + 1}.png`)"
								:alt="answer.alpabet"
								width="137"
								height="199"
							/>
							<button type="button" class="quiz_btn u-rock u-justify" @click="addAnswer(index)">
								{{ answer.text }}
							</button>
						</li>
					</ul>
					<!-- 最後のページ -->
					<div class="answer_btnNext --last" v-if="completed">
						<button type="button" class="u-rock" @click="divideLevel()">
							<div><span>あなたのクレハの</span><span>理解度を見る</span></div>
							<img src="../assets/img/kurehaTest/arrow.svg" alt="" width="50" height="17.5" />
						</button>
					</div>
				</div>
				<!-- 結果発表部分 -->
				<div class="result_container" v-if="isResult">
					<div class="result_leadImg u-textC">
						<img src="../assets/img/kurehaTest/result_title.png" alt="結果発表" width="1041" height="431" />
					</div>
					<p class="result_leadDesc u-bold u-textC u-ls01">
						{{ resultContents[userLevel].lead }}
					</p>
					<p class="result_score u-rock" v-if="userLevel < 2">
						5問中<span class="lg">{{ totalScore }}</span
						>問正解
					</p>
					<p class="result_score u-rock" v-if="userLevel == 2">
						<span class="lg ja">全問正解!</span>
					</p>
				</div>
			</section>
			<div class="innerResult" v-if="isResult">
				<p class="innerResult_lead u-rock u-textC">
					そんなあなたのクレハの環境と<br class="u-ds-sp" />社会への取り組みの理解度は…
				</p>
				<div class="innerResult_arrow u-textC">
					<img src="../assets/img/kurehaTest/icon_arrow_white.png" alt="" width="201" height="81" />
				</div>
				<div class="innerResult_titleSet">
					<div class="innerResult_fuki">
						<picture>
							<source
								:srcset="require(`@/assets/img/kurehaTest/fuki0${userLevel + 1}_pc.png`)"
								media="(min-width: 901px)"
								width="325"
								height="321"
							/>
							<img :src="require(`@/assets/img/kurehaTest/fuki0${userLevel + 1}_sp.png`)" alt="" width="441" height="486" />
						</picture>
					</div>
					<p class="innerResult_title u-rock u-textC">
						<span class="lg">{{ resultContents[userLevel].title[0] }}</span
						>{{ resultContents[userLevel].title[1] }}
					</p>
				</div>
				<p class="innerResult_desc u-bold u-justify">
					{{ resultContents[userLevel].desc }}
				</p>
				<div class="innerResult_illust u-textC">
					<img :src="require(`@/assets/img/kurehaTest/result_obj0${userLevel + 1}.png`)" alt="" />
					<p v-if="userLevel === 0" class="innerResult_desc innerResult_desc--note u-bold u-justify">
						※ラップを体に巻き付けるなどの行為は危険です。<br class="u-ds-sp" />食品包装用途以外に使用しないでください。
					</p>
				</div>
				<div class="answer_btnNext --restart">
					<button type="button" class="u-rock" @click="restartQuiz()">
						もう一度挑戦！
						<img src="../assets/img/kurehaTest/arrow.svg" alt="" width="50" height="17.5" />
					</button>
				</div>
				<div class="innerResult_share">
					<p class="innerResult_shareTitle u-rock u-textC u-ls01">検定結果をシェア</p>
					<div class="innerResult_btns">
						<SnsSharing :yourTotalScore="totalScore" :yourLevel="resultContents[userLevel].shareText" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Blank from '@/components/icons/Blank.vue';
import IconBase from '@/components/IconBase.vue';
import KurehaArrow from '@/components/icons/KurehaArrow.vue';
import Star from '@/components/icons/Star.vue';
import SnsSharing from '../components/SnsSharing.vue';

export default {
	name: 'kureha-quiz',
	components: {
		Blank,
		IconBase,
		KurehaArrow,
		Star,
		SnsSharing,
	},
	data() {
		return {
			// isResult: false,
			pageIndex: 0,
			answers: [],
			correct: [2, 1, 1, 0, 2],
			starColors: [],
			questionIndex: 0,
			totalScore: 0,
			userLevel: 0,
			isAnswer: false,
			questions: [
				// Q1
				{
					correctNum: 2,
					question: [
						'＜NEWクレラップ＞の特徴のうち、\n環境負荷の低減や社会問題の解消に\n貢献しているものはどれ？',
						'＜NEWクレラップ＞の特徴のうち、\n環境負荷の低減や社会問題の解消に貢献しているものはどれ？',
					],
					answers: [
						{
							alpabet: 'A',
							text: 'パッケージを軽量化したことで、製品の生産コストや環境コストを削減することができた。',
						},
						{
							alpabet: 'B',
							text:
								'<NEWクレラップ>のカット刃はとても薄くできていて、使い終わったら小さく折りたためるため、家庭内のごみの量を削減できる。',
						},
						{
							alpabet: 'C',
							text:
								'酸素や水蒸気を通しにくく、食品の劣化を遅らせることができるため、食品廃棄量の削減や食糧資源の有効化につながる。',
						},
					],
					answerComment:
						'酸素や水蒸気を通しにくく、食品の劣化を遅らせることができるため、食品廃棄量の削減や食糧資源の有効化につながる。',
					answerDesc:
						'現在、世界での食料廃棄は年間約13億トン、日本での食品ロスは約612万トンと試算されています(平成29年度 農林水産省推計)。食品は、劣化して食べられなくなると廃棄されますが、劣化する原因はさまざまです。しかし、酸化や乾燥が原因である場合には酸素や水蒸気を通しにくくする包装技術によって、食品の劣化を遅らせることができます。',
					answerLink: [
						'<NEWクレラップ>の開発ストーリーを⾒る',
						'https://www.kureha.co.jp/development/story/newkurewrap.html',
					],
				},
				// Q2
				{
					correctNum: 1,
					question: [
						'次のうちクレハが独自に開発した\n＜フォートロンKPS＞の説明として\n正しいのはどれ？',
						'次のうちクレハが独自に開発した\n＜フォートロンKPS＞の説明として正しいのはどれ？',
					],
					answers: [
						{
							alpabet: 'A',
							text: '主にプラント排気設備や浄水施設に使われ、大気汚染や水質汚濁防止が期待されている。',
						},
						{
							alpabet: 'B',
							text:
								'自動車の部品や電装品の外装などに使われ、自動車の重量を軽くすることで、燃費の向上を図り、温室効果ガスの削減が期待される。',
						},
						{
							alpabet: 'C',
							text:
								'ソーセージやハムの鮮度・品質を長時間保持するための食品用フィルムの原料として使われ、食品廃棄の削減に貢献している。',
						},
					],
					answerComment:
						'自動車の部品や電装品の外装などに使われ、自動車の重量を軽くすることで、燃費の向上を図り、温室効果ガスの削減が期待される。',
					answerDesc:
						'当社は1980年代に、それまではもろい材料とされていたポリフェニレンサルファイド樹脂(PPS)の弱点を克服した分子構造(架橋構造を持たない直鎖状)を持つPPS＜フォートロンKPS＞の開発に成功しました。このPPSは、成形加工が容易であると同時に熱安定性に優れ、伸びや衝撃にも強い素材です。また、厳しい電気的特性にも対応するなど、自動車部品の金属代替用途として求められる特性を兼ね備えています。主に、耐熱性が求められるエンジン周辺や電装品の外装に使用されるなど、年々需要が増加しています。',
					answerLink: ['＜フォートロンKPS＞の製品説明を⾒る', 'https://www.kureha.co.jp/business/material/kps.html'],
				},
				// Q3
				{
					correctNum: 1,
					question: [
						'主に＜NEWクレラップ＞を生産している\n茨城県の樹脂加工事業所の環境への\n取り組みで正しいのは？',
						'主に＜NEWクレラップ＞を生産している\n茨城県の樹脂加工事業所の環境への取り組みで正しいのは？',
					],
					answers: [
						{
							alpabet: 'A',
							text:
								'＜NEWクレラップ＞の加工過程で余ってしまったラップの芯を、事業所スタッフの子どもに配布し、図画工作の材料として再利用できる制度がある。',
						},
						{
							alpabet: 'B',
							text:
								'生産ロスの発生抑制や、再資源化に取り組んだ結果、2021年度にラップの原料であるポリ塩化ビニリデン由来廃棄物の最終処分量ゼロを達成。',
						},
						{
							alpabet: 'C',
							text:
								'いわき事業所で生産された素材を茨城県の樹脂加工事業所まで運ぶ際に、電気自動車を採用。カーボンニュートラルへの実現に向けた取り組みを行っている。',
						},
					],
					answerComment:
						'生産ロスの発生抑制や、再資源化に取り組んだ結果、2021年度にラップの原料であるポリ塩化ビニリデン由来廃棄物の最終処分量ゼロを達成。',
					answerDesc:
						'樹脂加工事業所では、生産ロスの発生抑制や、生産ロス分を再利用した製品の開発および再資源化を積極的に実施。排出量の大半を占めるラップの原料であるポリ塩化ビニリデン由来廃棄物の最終処分量ゼロを目指し、処分方法の変更を行いました。これにより、埋立量を徐々に削減し、2020年度のポリ塩化ビニリデン由来廃棄物の埋立量は、当初計画の約30％削減を達成。2021年度からは最終処分量ゼロを達成しました。資源循環を推進し最終処分量を削減することは、当社においても重要な課題であり、これからも産業廃棄物ゼロエミッションに向けて目標を立てて推進していきます。',
					answerLink: ['クレハの廃棄物とリサイクルについて知る', 'https://www.kureha.co.jp/csr/environment/recycle.html'],
				},
				// Q4
				{
					correctNum: 0,
					question: [
						'シエールガスの掘削機器に使われる\n「Kuredux」の特性で、\n環境負荷の低減に貢献しているのは？',
						'シエールガスの掘削機器に使われる「Kuredux」の特性で、\n環境負荷の低減に貢献しているのは？',
					],
					answers: [
						{
							alpabet: 'A',
							text: '生分解性が優れているので、自然環境の中で微生物が⼆酸化炭素と水に分解し、生態系の⼀部となる。',
						},
						{
							alpabet: 'B',
							text: '経年劣化しても、高温で溶かせば素材として再利用できるので、廃棄することなく使い続けることができる。',
						},
						{
							alpabet: 'C',
							text: '⼈間が食べられる素材でできており、加熱調理すれば、捨てることなく美味しく食べられる。',
						},
					],
					answerComment: '生分解性が優れているので、自然環境の中で微生物が⼆酸化炭素と水に分解し、生態系の⼀部となる。',
					answerDesc:
						'Kureduxはシェールオイル・ガスの掘削機器として利用され、エネルギー源の確保に貢献するとともに、環境負荷の低減も考慮された製品です。本製品はセルロースと同等の生分解性を有し、コンポスト（堆肥を集めてできたごみ処理場）内で1ヶ月以内に微生物によって⼆酸化炭素と水に分解します。また生成されたコンポストの安全性も確認されています。クレハPGA＜Kuredux＞は欧州、日本で生分解性プラスチックとして認証を受けています。＜Kuredux＞は生分解プラスチックとしてISO14855、ASTM D6400、EN 13432の規格に適合しており、下記の認証を取得しています。',
					answerLink: ['＜Kuredux＞の製品説明を⾒る', 'https://www.kureha.co.jp/business/material/kuredux.html'],
				},
				// Q5
				{
					correctNum: 2,
					question: [
						'次の製品のうち、電気自動車の\nリチウムイオン電池用バインダーとして\nCO2排出削減に貢献しているのはどれ？',
						'次の製品のうち、電気自動車のリチウムイオン電池用バインダーとしてCO2排出削減に貢献しているのはどれ？',
					],
					answers: [
						{
							alpabet: 'A',
							text: '慢性腎不全用剤 クレメジン・コバルジン',
						},
						{
							alpabet: 'B',
							text: '球状活性炭 BAC',
						},
						{
							alpabet: 'C',
							text: 'ポリフッ化ビニリデン樹脂 KFポリマー',
						},
					],
					answerComment: 'ポリフッ化ビニリデン樹脂 KFポリマー',
					answerDesc:
						'当社のKFポリマーは、活物質への高い接着性、広い電位領域での電気的安定性とリチウムイオンの高い透過性を⽰し、リチウムイオン電池用バインダーとして求められるさまざまな性能を十分に満たし、長期信頼性が求められる車載用のリチウムイオン電池に広く使用されています。さらに、リチウムイオン電池バインダーの先駆者として、全固体電池などの次世代車載用への対応を積極的に進めています。',
					answerLink: ['＜KFポリマー＞の製品説明を⾒る', 'https://www.kureha.co.jp/business/material/kfpolymer.html'],
				},
			],
			resultContents: [
				{
					lead: '残念！クレハマスターへの道のりは\nまだまだ長そうです…',
					title: ['NEWクレラップ', '並の薄さです'],
					titleImg: {
						sp: '../assets/img/kurehaTest/fuki01_sp.png',
						pc: '../assets/img/kurehaTest/fuki01_pc.png',
					},
					desc:
						'あなたはクレハについてほんの⼀部しか知らないようです。そう、それは薄さ0.0010mmのNEWクレラップくらい。しかし、そんな薄いNEWクレラップは、密着性に優れ、くっつきやすく剥がれにくい性質が魅力。食品の酸化を防ぎ、新鮮さを保ちます。この検定での学びは、いつまで経ってもNEWクレラップのごとくあなたの頭の中に密着して、忘れることはないでしょう。',
					shareText: 'クレラップの薄さ',
				},
				{
					lead: '惜しい！\nクレハマスターの称号はもう目の前！',
					title: ['メトコナゾールの\nポテンシャル', '並の高さです'],
					titleImg: {
						sp: '../assets/img/kurehaTest/fuki02_sp.png',
						pc: '../assets/img/kurehaTest/fuki02_pc.png',
					},
					desc:
						'メトコナゾールとは、クレハが発明した農業・園芸用殺菌剤。麦類、トウモロコシ、ナタネ、ダイズ、芝、果樹などに発生する幅広い病害に対し高い防除効果を⽰します。このメトコナゾールは、1986年に開発され、約10年後に「日本化学工業協会第28回技術賞」を受賞。その5年後に「日本農薬学会業績賞（技術）」を受賞しました。そして、現在40ヵ国以上で農薬登録を取得し、世界の農業を⽀えています。あなたの努力や頑張りも、このメトコナゾールのように着実に周囲に認められ、やがて大きな実を結ぶことでしょう。',
					shareText: 'メトコナゾールのポテンシャルの高さ',
				},
				{
					lead: 'おめでとうございます！\n晴れてあなたは正真正銘の\nクレハマスターです！',
					title: ['KFポリマーの性能\n', '並の幅広さです'],
					titleImg: {
						sp: '../assets/img/kurehaTest/fuki03_sp.png',
						pc: '../assets/img/kurehaTest/fuki03_pc.png',
					},
					desc:
						'KFポリマーとは、クレハが日本で最初に⽣産開始したポリフッ化ビニリデン樹脂（PVDF）のこと。高い耐熱性、耐薬品性、撥水性、耐油性に加え、汎用樹脂のように成形加工もできるという「超優秀素材」。あなたの類まれなるポテンシャルの高さは、まさにKFポリマーそのもの。ある時はバルブ、ある時は太陽電池の保護フィルム、またある時は釣り糸になったりと、変幻自在に姿を変えるKFポリマーのように、将来あなたが幅広い分野で活躍している姿が目に浮かびます。',
					shareText: 'KFポリマーの性能の幅広さ',
				},
			],
		};
	},
	methods: {
		// 回答ボタンで発火するイベント
		addAnswer: function (index) {
			// 回答した選択肢を配列に追加
			this.answers.push(index);
			// 合否判定し正解すれば合計得点に追加
			this.calcScore(index);
			// 次のページへ
			this.nextPage();
		},
		// 質問ページから解答ページへ
		nextPage: function () {
			// if (!this.completed) {
			this.pageIndex++;
			this.isAnswer = !this.isAnswer;
			// }
			this.scrollToTop();
		},
		// 解答ページから質問ページへ
		nextQuestion: function () {
			this.nextPage();
			this.questionIndex++;
		},
		// 合否を判定・合計得点計算
		calcScore: function (select) {
			//selectは選んだ回答が入るA=0,B=1,C=2
			const yourSelect = select;
			const correctAnswer = this.questions[this.questionIndex].correctNum;
			if (yourSelect === correctAnswer) {
				this.totalScore++;
				this.starColors.push('#ffe200');
			} else {
				this.starColors.push('#585858');
			}
		},

		// 最初から問題をやり直す
		restartQuiz: function () {
			this.scrollToTop();
			this.pageIndex = 0;
			this.questionIndex = 0;
			this.totalScore = 0;
			this.userLevel = 0;
			this.isAnswer = false;
			this.starColors = [];
		},

		// ページ最上部へスクロール
		scrollToTop: function () {
			window.scrollTo(0, 0);
		},

		// 問題数から自分の解答を格納する配列の長さを設定する
		initAnswersArray: function () {
			this.answers = Array(this.questions.length);
		},

		// ユーザーのレベルを判定
		divideLevel: function () {
			if (this.totalScore < 3) {
				this.userLevel = 0;
			} else if (this.totalScore < 5) {
				this.userLevel = 1;
			} else {
				this.userLevel = 2;
			}
			this.nextQuestion();
		},
	},
	computed: {
		// 現在のページ番号を取得する
		currentPage: function () {
			return this.pageIndex;
		},
		// 現在の問題番号を取得する
		currentQuestion: function () {
			return this.questions[this.questionIndex];
		},
		// 現在のページ番号を取得
		completed: function () {
			return this.pageIndex === this.questions.length * 2 - 1;
		},
		// 結果のページかどうかを取得
		isResult: function () {
			return this.pageIndex > this.questions.length * 2 - 1;
		},
	},
	// 合計得点からレベル別にわける
	mounted() {},
};
</script>

<style scoped lang="scss">
@use 'sass:math';
@use 'sass:string';
//pxをvw/vhに変換
@function vw($size, $viewport: 768) {
	$rate: math.div(100, $viewport);
	@return $rate * $size * 1vw;
}
@function vw_lg($size, $viewport: 1366) {
	$rate: math.div(100, $viewport);
	@return $rate * $size * 1vw;
}
p,
h1,
h2,
ul,
li,
a {
	margin: 0;
}
img {
	vertical-align: top;
}

button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	outline: none;
	padding: 0;
	appearance: none;
}
@mixin pc {
	@media print, screen and (min-width: 901px) {
		@content;
	}
}
// 文末揃え
.u-justify {
	text-align: justify;
	text-justify: inter-character; //for Firefox
}

.u-pl {
	white-space: pre-line;
}
.u-palt {
	font-feature-settings: 'palt';
}
.u-ds-sp {
	@include pc {
		display: none;
	}
}
.u-ds-pc {
	display: none;
	@include pc {
		display: block;
	}
}
.u-bold {
	font-weight: bold;
}

.u-rock {
	font-family: 'RocknRoll One', sans-serif;
}

.u-textC {
	text-align: center;
}

.u-ls01 {
	letter-spacing: 0.1em;
}
.wrapper {
	padding: vw(210) vw(40) vw(80);
	background-color: #3fa300;
	@include pc {
		padding: 180px 0 120px;
	}
}
.inner {
	padding: 10px;
	background-color: #3fa300;
	background-image: repeating-linear-gradient(-45deg, #fff, #fff 3px, transparent 0, transparent 6px);
	box-shadow: 6px 6px 12px 3px rgba(#000000, 0.2);
	border-radius: 20px;
	@include pc {
		padding: 15px;
		position: relative;
		width: 80%;
		max-width: 1030px;
		margin-inline: auto;
		background-image: repeating-linear-gradient(-45deg, #fff, #fff 4px, transparent 0, transparent 8px);
		border-radius: 25px;
		outline: 20px solid #fff;
		box-shadow: 26px 26px 32px 13px rgba(#000000, 0.2);
	}
	&.is-result {
		padding: 10px 10px 0;
		@include pc {
			padding: 15px 15px 0;
		}
	}
}

.contents {
	position: relative;
	background-color: #fff;
	border-radius: 20px;
	padding: 0 vw(40) vw(110);
	@include pc {
		border-radius: 25px;
		padding: 55px 120px 105px;
	}
	&.is-result {
		padding: 0 vw(40) vw(140);
		@include pc {
			padding: 54px 120px 150px;
		}
	}

	.titleBox {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: vw(-140);
		left: 50%;
		width: vw(420);
		height: vw(180);
		background-color: #fff;
		border-radius: 11px;
		transform: translateX(-50%);
		@include pc {
			width: 380px;
			height: 150px;
			border-radius: 20px;
			top: -120px;
		}
	}
	.titleImg {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: vw(347);
		// background-color: red;
		@include pc {
			width: 80%;
			margin-bottom: -10px;
		}
	}
}

.quiz {
	&_container {
		position: relative;
		padding-top: vw(70);
		@include pc {
			padding-top: 0;
		}
	}
	&_stars {
		position: absolute;
		top: 16px;
		right: -6px;
		display: flex;
		flex-direction: column;
		gap: vw(6);
		width: vw(36);
		@include pc {
			flex-direction: row;
			top: -23px;
			right: -87px;
			width: 195px;
			gap: 8px;
		}
	}
	&_star {
		display: inline-block;
		width: 100%;
		height: 100%;
		line-height: 1;
	}
	&_num {
		text-align: center;
		img {
			display: inline-block;
			&.is-1 {
				width: 74px;
				@include pc {
					width: 148px;
					margin-right: 20px;
				}
			}
			&.is-2 {
				width: 62px;
				@include pc {
					width: 164px;
					margin-right: 20px;
				}
			}
			&.is-3 {
				width: 72.5px;
				@include pc {
					width: 153px;
					margin-right: 20px;
				}
			}
			&.is-4 {
				width: 88px;
				@include pc {
					width: 176px;
					margin-right: 20px;
				}
			}
			&.is-5 {
				width: 85.5px;
				@include pc {
					width: 170px;
					margin-right: 20px;
				}
			}
		}
	}
	&_desc {
		margin-top: 2em;
		text-align: center;
		font-weight: bold;
		font-size: 14px;
		line-height: calc(50 / 28);
		white-space: pre-line;
		@include pc {
			margin-top: 0.8em;
			font-size: 22px;
			line-height: calc(40 / 22);
			letter-spacing: 0.1em;
		}
	}
	&_img {
		margin-top: 33px;
		width: 100%;
		@include pc {
			margin-top: 50px;
			&.is-7 {
				text-align: center;
				img {
					width: 80%;
				}
			}
		}
	}

	&_btnItems {
		margin-top: 50px;
		@include pc {
			margin-top: 70px;
			width: 100%;
		}
	}

	&_btnItem {
		position: relative;
		max-width: 100%;
		min-height: 145px;
		color: #00797f;
		margin-right: 0.3em;
		margin-left: 1.5em;
		@include pc {
			min-height: 140px;
			// height: 140px;
			border-radius: 100vmax;
			margin-right: 0.7em;
			margin-left: 2.5em;
		}
		@media (hover: hover) {
			transition: transform 0.2s ease-out;
			&:hover {
				transform: translateX(8px);
			}
		}
		@media (hover: none) {
			transition: transform 0.1s ease-out;
			&:hover {
				transform: scale(0.9);
			}
		}
		&::after {
			content: '';
			display: block;
			position: absolute;
			right: -5px;
			bottom: -5px;
			z-index: 0;
			width: 100%;
			height: 100%;
			background-color: currentColor;
			border-radius: 35px;
			@include pc {
				right: -10px;
				bottom: -10px;
				border-radius: 100vmax;
			}
		}
		img {
			display: inline-block;
			position: absolute;
			top: 50%;
			left: -8%;
			z-index: 2;
			width: 55px;
			transform: translateY(-52%);
			@include pc {
				top: 54%;
				left: -3.5%;
				width: 90px;
			}
		}
		button {
			display: flex;
			flex-direction: column;
			justify-content: center;
			position: relative;
			width: 100%;
			min-height: 145px;
			padding: 1.5em 1.8em 3em 3.3em;
			background-color: #ffe200;
			// background-color: blue;
			font-size: 13px;
			line-height: calc(44 / 26);
			z-index: 1;
			border-radius: 35px;
			letter-spacing: -0.05em;
			@include pc {
				padding: 1em 17% 1em 4.5em;
				font-size: 20px;
				line-height: calc(34 / 20);
				min-height: 140px;
				// height: 140px;
				border-radius: 100vmax;
			}
			&::after {
				content: '';
				display: inline-block;
				align-self: center;
				position: absolute;
				bottom: 1.2em;
				left: 45%;
				width: 2em;
				height: 0.7em;
				background-image: url('../assets/img/kurehaTest/arrow.svg');
				background-size: contain;
				background-repeat: no-repeat;
				background-position: center center;
				@include pc {
					bottom: 48%;
					left: auto;
					right: 5.5%;
					width: 50px;
					height: 18px;
					transform: translateY(50%);
				}
			}
		}
		& + & {
			margin-top: 2em;
			@include pc {
				margin-top: 3em;
			}
		}
	}
}

.answer_lead {
	margin-bottom: 50px;
	@include pc {
		margin-bottom: 80px;
	}
}

.answer_leadTitle {
	margin-top: 0.75em;
	font-weight: bold;
	font-size: 22.5px;
	text-align: center;
	@include pc {
		margin-top: 0.2em;
		font-size: 40px;
	}
}

.answer_leadImg {
	position: relative;
	text-align: center;
	margin-top: 10px;
	@include pc {
		margin-top: 15px;
	}

	img {
		width: 75px;
		@include pc {
			width: 130px;
		}
	}
}

.answer_comment {
	margin-top: -1.8em;
	padding: 2.4em 2em;
	background-color: #3f9b00;
	// background-color: red;
	color: #fff;
	font-size: 13px;
	line-height: 2;
	border-radius: 15px;
	@include pc {
		margin-top: -40px;
		padding: 2em;
		font-size: 24px;
		line-height: calc(44 / 24);
		border-radius: 20px;
	}
}
.answer_desc {
	margin-top: 2.2em;
	font-weight: bold;
	font-size: 12px;
	line-height: calc(46 / 24);
	@include pc {
		margin-top: 4em;
		font-size: 18px;
		line-height: calc(36 / 18);
	}
}

.answer_link {
	margin-top: 2.3em;
	display: block;
	width: 100%;
	position: relative;
	color: #00797f;
	font-weight: bold;
	font-size: 12px;
	box-sizing: border-box;
	@include pc {
		display: inline-block;
		width: auto;
		margin-top: 1.3em;
		font-size: 18px;
	}
	a {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.kureha_arrow {
		width: 100%;
		max-width: 100%;
		bottom: -10%;
	}
	.icon_base {
		margin-right: 0.5em;
		width: 1em;
		height: 1em;
		@include pc {
			margin: 0 0.7em;
		}
	}
}

.answer_btnNext {
	position: relative;
	width: 95%;
	margin: 60px auto 0;
	color: #00797f;
	border-radius: 100vmax;
	transform: translateX(-0.1em);
	@include pc {
		margin-top: 100px;
		transform: none;
		width: 390px;
	}

	&::after {
		content: '';
		display: block;
		position: absolute;
		right: -5px;
		bottom: -5px;
		z-index: 0;
		width: 100%;
		height: 100%;
		background-color: currentColor;
		border-radius: 100vmax;
		@include pc {
			right: -10px;
			bottom: -10px;
		}
	}
	&.--last {
		@include pc {
			width: 740px;
			max-width: 100%;
		}
		button {
			line-height: calc(55 / 40);
			padding-top: 0.6em;
			padding-bottom: 0.7em;
			text-align: left;
			@include pc {
				padding: 0.3em 1.4em 0.5em 1.6em;
			}
			span {
				display: inline-block;
			}
		}
	}
	&.--restart {
		width: 83%;
		margin-top: 40px;
		max-width: 285px;
		@include pc {
			max-width: 100%;
			width: 450px;
		}
		&::after {
			background-color: #fff;
		}
		button {
			font-size: 17.5px;
			@include pc {
				padding: 0.4em 1.4em 0.5em 1.6em;
				font-size: 35px;
			}
		}
	}

	a,
	button {
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		padding: 0.35em 1em 0.5em 1.3em;
		width: 100%;
		height: 100%;
		font-size: 20px;
		z-index: 1;
		background-color: #ffe200;
		color: #00797f;
		letter-spacing: 0.1em;
		border-radius: 100vmax;
		box-sizing: border-box;
		@include pc {
			justify-content: space-between;
			padding: 0.3em 1.4em 0.5em 1.6em;
			box-sizing: border-box;
			font-size: 35px;
		}
		@media (hover: hover) {
			transition: all 0.2s ease-out;
			&:hover {
				opacity: 1 !important;
				background-color: #545454 !important;
			}
		}
	}
	img {
		width: 1.25em;
		margin-top: 0.2em;
		@include pc {
			width: 1.5em;
			margin-top: 0.3em;
		}
	}
}

.result_container {
	padding-top: vw(90);
	@include pc {
		padding-top: 0;
		margin-top: -10px;
	}
}

.result_leadImg {
	width: 260px;
	margin-left: auto;
	margin-right: auto;
	@include pc {
		width: 520px;
	}
	img {
		animation: showUp 1s cubic-bezier(0.34, 1.56, 0.64, 1) 1 forwards;
		@keyframes showUp {
			from {
				transform: scale(0);
			}
			to {
				transform: scale(1);
			}
		}
		@include pc {
			margin-right: 30px;
		}
	}
}

.result_leadDesc {
	margin-top: 2em;
	font-size: 14px;
	white-space: pre-line;
	line-height: calc(50 / 28);
	@include pc {
		margin-top: 1em;
		font-size: 22px;
		line-height: calc(36 / 22);
		white-space: nowrap;
	}
}

.result_score {
	display: flex;
	align-items: flex-end;
	justify-content: center;
	margin-top: 2em;
	font-size: 22.5px;
	letter-spacing: 0.1em;
	@include pc {
		font-size: 30px;
	}
	.lg {
		display: inline-block;
		margin: 0 0.05em 0.25em;
		font-size: 100px;
		@include pc {
			font-size: 160px;
		}
		&.ja {
			display: block;
			font-size: 66px;
			white-space: nowrap;
			@include pc {
				font-size: 60px;
			}
		}
	}
}

.innerResult {
	position: relative;
	margin-top: vw(-50);
	width: calc(100% + 20px);
	margin-left: -10px;
	padding: vw(80) vw(60) 30px;
	background-color: #00797f;
	border-radius: 0 0 20px 20px;
	box-sizing: border-box;
	color: #fff;
	& > * {
		position: relative;
		z-index: 1;
	}
	@include pc {
		margin-top: -60px;
		margin-left: -35px;
		padding: 65px min(vw_lg(140), 140px) 25px;
		position: relative;
		width: calc(100% + 70px);
		max-width: 1110px;
		border-radius: 0 0 50px 50px;
	}
	&::after {
		content: '';
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 0;
		background-color: #ffe200;
		width: 100%;
		height: 150px;
		border-radius: 0 0 20px 20px;
		@include pc {
			bottom: -30px;
			height: 170px;
			border-radius: 0 0 50px 50px;
		}
	}

	&_lead {
		font-size: 15px;
		letter-spacing: 0.1em;
		white-space: nowrap;
		@include pc {
			font-size: 22px;
		}
	}
	&_arrow {
		margin-top: 30px;
		img {
			width: 50px;
			@include pc {
				width: 70px;
			}
		}
	}
	&_titleSet {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 30px;
		@include pc {
			position: relative;
			width: 100%;
			align-items: flex-start;
			margin-top: 90px;
		}
	}

	&_fuki {
		width: 110px;
		@include pc {
			width: 162px;
			position: absolute;
			// top: -90px;
			bottom: 25px;
			right: 0;
			z-index: 0;
		}
	}
	&_title {
		margin-top: 0.8em;
		font-size: 17.5px;
		letter-spacing: 0.1em;
		@include pc {
			position: relative;
			z-index: 1;
			margin-top: 0;
			padding-right: 162px;
			font-size: 30px;
			text-align: left;
		}
		.lg {
			display: block;
			font-size: 2em;
			line-height: 1.3;
			letter-spacing: 0;
			white-space: pre;
			@include pc {
				display: inline;
				line-height: calc(72 / 60);
				margin-right: 0.2em;
				white-space: pre-line;
			}
		}
	}
	&_desc {
		margin-top: 2.5em;
		font-size: 12px;
		line-height: calc(46 / 24);
		@include pc {
			margin-top: 1.8em;
			font-size: 16px;
			line-height: calc(36 / 16);
		}
		&--note {
			margin-top: 2em;
			font-size: 11px;
			line-height: calc(40 / 22);
			@include pc {
				margin-top: 2.4em;
				font-size: 16px;
				line-height: calc(36 / 16);
				text-align: center;
			}
		}
	}
	&_illust {
		margin-top: 30px;
		@include pc {
			margin-top: 50px;
		}
	}
	&_share {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 80px;
		@include pc {
			flex-direction: row;
			justify-content: center;
			margin-top: 165px;
		}
	}
	&_shareTitle {
		color: #00797f;
		font-size: 17.5px;
		@include pc {
			font-size: 30px;
		}
	}
	&_btns {
		margin-top: 10px;
		@include pc {
			margin-top: 0;
			margin-left: 35px;
			transform: translateY(8px);
		}
	}
}
</style>
